import type { AboutMeFeedbackItem } from '../api/colleagueFeedbackApi';
import { parseApiDateTime } from './parseApiDateTime';

export type AboutMeEntry = {
  id: number;
  ratings: Record<string, number>;
  feedback: string;
  submittedAt: Date;
};

export function mapAboutMeFeedbackItems(items: AboutMeFeedbackItem[]): AboutMeEntry[] {
  return items.map((i) => ({
    id: i.id,
    ratings: i.ratings,
    feedback: i.feedback ?? '',
    submittedAt: parseApiDateTime(i.submittedAt),
  }));
}
